<template>
  <v-card outlined>
    <v-card-title>
      Occupancy Chart
    </v-card-title>
    <v-divider class="mx-4"/>
    <v-card-text>
      <im-bar-chart :chart-data="chart_data" :options="chart_options" :height="250"/>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {

    components: {
      'im-bar-chart': () => import('@/components/Statistics/BarChart')
    },

    props: {
      occupancies: Object
    },

    computed: {

      chart_data() {
        return {
          labels: this.occupancies.labels,
          datasets: [
            {
              label: 'Available',
              data: this.occupancies.datasets.hotel.available,
              borderColor: "#00B0FF",
              backgroundColor: "#00B0FF",
              yAxisID: 'availability',
            },
            {
              label: 'Booked',
              data: this.occupancies.datasets.hotel.booked,
              borderColor: "#00E676",
              backgroundColor: "#00E676",
              yAxisID: 'availability',
            }
          ]
        }
      },

      chart_options() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          fill: false,
          tooltips: {
            mode: 'index'
          },
          legend: {
            position: 'bottom'
          },
          scales: {
            yAxes: [
              {
                id: 'availability',
                type: 'linear',
                ticks: {
                  min: 0
                }
              }
            ]
          }
        }
      }

    }


  }
</script>